import { Provider, STORAGE_KEY } from '../constants'

export const get = (provider: Provider, key, defaultValue?) => {
  const providerInstance = getStorageProvider(provider)
  const state = getStorageState(providerInstance)[key]

  if (state === undefined) {
    return defaultValue
  }

  return state
}

export const set = (provider: Provider, key, value) => {
  const providerInstance = getStorageProvider(provider)

  return setStorageState(providerInstance, key, value)
}

const getStorageState = (providerInstance) => {
  const state = providerInstance.getItem(STORAGE_KEY)

  if (state === null) {
    return {}
  }

  return JSON.parse(state)
}

const setStorageState = (providerInstance, key, value) => {
  const state = getStorageState(providerInstance)

  state[key] = value
  providerInstance.setItem(STORAGE_KEY, JSON.stringify(state))
}

const getStorageProvider = (provider: Provider) => {
  switch (provider) {
    case Provider.LOCAL_STORAGE:
      return window.localStorage
    case Provider.SESSION_STORAGE:
      return window.sessionStorage
  }
}
